module.exports = __webpack_public_path__ + "static/img/37.9e6a427.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/question/37.png
// module id = MKxy
// module chunks = 1